// src/pages/TicketPurchase.js
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { QRCodeCanvas } from 'qrcode.react'; // Assurez-vous d'installer: npm install qrcode.react
import '../styles/TicketPurchase.css';
import moviesData from '../data/movies.json';

const TicketPurchase = () => {
    const { id } = useParams();
    const film = moviesData.find(movie => movie.id === parseInt(id));

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        paymentMethod: 'credit', // 'credit' ou 'mobile'
    });
    const [paymentCompleted, setPaymentCompleted] = useState(false);
    const [ticketInfo, setTicketInfo] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handlePayment = async (e) => {
        e.preventDefault();
        // SIMULATION DU PROCESSUS DE PAIEMENT :
        // Dans un environnement réel, vous intégrerez un service de paiement sécurisé (ex: Stripe, Flutterwave, Paystack).
        // Toutes les données sensibles seront transmises via une connexion HTTPS à un backend sécurisé.
        console.log('Paiement en cours pour :', formData);

        // Simulation d'un délai de traitement
        setTimeout(() => {
            // Génération d'un ticket fictif
            const ticketNumber = Math.floor(Math.random() * 1000000);
            const validUntil = new Date();
            validUntil.setHours(validUntil.getHours() + 3); // Le ticket est valable 3 heures après le scan
            const ticket = {
                ticketNumber,
                filmTitle: film.titre,
                purchaser: formData.name,
                email: formData.email,
                phone: formData.phone,
                paymentMethod: formData.paymentMethod,
                validUntil: validUntil.toISOString(),
            };
            setTicketInfo(ticket);
            setPaymentCompleted(true);
        }, 2000);
    };

    // Affichage du ticket après paiement
    if (paymentCompleted && ticketInfo) {
        return (
            <div className="ticket-container">
                <h1>Votre E-Ticket</h1>
                <div className="ticket-details">
                    <p><strong>Film :</strong> {ticketInfo.filmTitle}</p>
                    <p><strong>Nom :</strong> {ticketInfo.purchaser}</p>
                    <p><strong>Ticket N° :</strong> {ticketInfo.ticketNumber}</p>
                    <p>
                        <strong>Valable jusqu'au :</strong> {new Date(ticketInfo.validUntil).toLocaleString()}
                    </p>
                    <p className="ticket-note">
                        Ce ticket est valable pendant 3 heures après son premier scan.
                    </p>
                </div>
                <div className="qr-code">
                    <QRCodeCanvas value={JSON.stringify(ticketInfo)} size={150} />
                    <p>Présentez ce QR Code à l'entrée.</p>
                </div>
            </div>
        );
    }

    return (
        <div className="ticket-purchase">
            <h1>Achat de Ticket pour {film.titre}</h1>
            <p>Choisissez votre méthode de paiement : carte bancaire ou paiement mobile.</p>
            <form onSubmit={handlePayment} className="purchase-form">
                <div className="form-group">
                    <label htmlFor="name">Nom Complet</label>
                    <input
                        type="text"
                        id="name"
                        name="name"
                        placeholder="Votre nom complet"
                        value={formData.name}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="email">Adresse E-mail</label>
                    <input
                        type="email"
                        id="email"
                        name="email"
                        placeholder="Votre e-mail"
                        value={formData.email}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="phone">Téléphone</label>
                    <input
                        type="tel"
                        id="phone"
                        name="phone"
                        placeholder="Votre numéro de téléphone"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="paymentMethod">Méthode de paiement</label>
                    <select
                        id="paymentMethod"
                        name="paymentMethod"
                        value={formData.paymentMethod}
                        onChange={handleChange}
                    >
                        <option value="credit">Carte Bancaire</option>
                        <option value="mobile">Paiement Mobile</option>
                    </select>
                </div>
                <button type="submit" className="submit-button">
                    Payer et Obtenir mon Ticket
                </button>
            </form>
            <p className="security-note">
                Vos informations de paiement sont sécurisées et transmises via une connexion HTTPS.
            </p>
        </div>
    );
};

export default TicketPurchase;
